<script>
  import { twMerge } from "tailwind-merge";

  const defaultMargin = "my-3";

  let classes = twMerge(defaultMargin, "!opacity-30", $$props.class);
</script>

<hr class={classes} />
